import { PlaneGeometry, MeshBasicMaterial, Mesh, DoubleSide } from "three"
import gsap from 'gsap'


export let dataStickers = []
export let creatingStickers = false

export const createStickers = (scene, stickersMaps) =>{
    const arrayStickerTexture = Object.values(stickersMaps)
    const geometrySticker = new PlaneGeometry(0.05, 0.05)

    for(let i=0; i < 18; i++){
    
    const materialSticker = new MeshBasicMaterial({
        map : arrayStickerTexture[i%arrayStickerTexture.length], 
        transparent: true, 
        side: DoubleSide, 
        depthWrite: false})

    const meshSticker = new Mesh(geometrySticker, materialSticker)
    meshSticker.position.x = (- Math.random() * 0.08) - 0.77
    meshSticker.position.y = (Math.random() * (0.14)) + 0.65
    meshSticker.position.z = (-Math.random() * 0.3) - 0.52

    meshSticker.rotation.y = Math.random() * (Math.PI / 3)

    dataStickers.push({
        meshSticker, 
        startPosition: meshSticker.position.clone(),
        speed: Math.random() + 0.1, 
    })
        scene.add(meshSticker)
    }
    creatingStickers = true
}

export const removeSticker = (scene) =>{
    creatingStickers = false
    dataStickers.forEach((obj) => {
        gsap.to(obj.meshSticker.scale, {
            x: 0, 
            y: 0, 
            z: 0,
            duration: 3,
            onComplete: () =>{
                scene.remove(obj.meshSticker)
                obj.meshSticker.geometry.dispose()
                obj.meshSticker.material.dispose()
            }
        })
    })
    dataStickers = []
}